module.exports = __webpack_public_path__ + "img/qr-code.0e3609f2.png";